/**
 *
 * @param {Helpers|string} table_selector
 * @param {string} show_all_btn_selector
 * @returns
 */
function ProductPriceTable(table_selector, show_all_btn_selector = '.show-all-params') {
    this.TABLE = hp(table_selector);

    this.BODY = null;
    this.BODY_ROWS = null;
    this.SHOW_ALL_BTN = null;
    this.BREAKPOINT = 10;

    if (this.TABLE.isEmpty()) {
        return;
    }

    this.setVariables(show_all_btn_selector);
    this.init();
}

ProductPriceTable.prototype = {
    setVariables: function (show_all_btn_selector) {
        let table = this.TABLE;

        this.BODY = table.find('.table-body')
        this.BODY_ROWS = this.BODY.find('.table-row')
        this.SHOW_ALL_BTN = table.find(show_all_btn_selector);

        let tempBREAKPOINT = table.data('row-bp')

        if (tempBREAKPOINT != null) {
            this.BREAKPOINT = parseInt(tempBREAKPOINT)
        }
    },

    init: function () {
        if (this.BODY_ROWS.count() <= this.BREAKPOINT) {
            return;
        }

        if (!this.isFullSize()) {
            this.hide();
        }

        this._setBTNEvent();
    },

    _setBTNEvent: function () {
        this.SHOW_ALL_BTN.on('click', (e) => {
            this.toggle(this.isFullSize());

            return this.TABLE.toggle('full-size');
        })
    },

    show: function () {
        this.BODY_ROWS.each((row, index) => {
            index++

            if (index > this.BREAKPOINT) {
                hp(row).css('display', '')
            }
        })
    },

    hide: function (BREAKPOINT = this.BREAKPOINT) {
        this.BODY_ROWS.each((row, index) => {
            index++

            if (index > BREAKPOINT) {
                hp(row).css('display', 'none')
            }
        })
    },

    /**
     *
     * @param {boolean} status
     * @returns
     */
    toggle: function (status) {
        return status ? this.hide() : this.show();
    },

    isFullSize: function () {
        return this.TABLE.hasClass('full-size');
    }
}

module.exports = ProductPriceTable;
